var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editBtn"},[_c('ColorTextBtn',{attrs:{"size":"small"},on:{"click":_vm.changePage}},[_vm._v("编辑")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }